export default "__VITE_ASSET__Ckx4bEdq__"